import { BLOCK_TYPE } from "contracts/enums/metrics";
import type { ContentBlock } from "contracts/report/blocks";
import { For, Show } from "solid-js";

export function BlockViewer(props: { blocks: ContentBlock[] }) {
  return (
    <div class="block-viewer">
      <For each={props.blocks}>
        {(block) => (
          <div class={`content-block block-${block.type}`}>
            <BlockView block={block} />
          </div>
        )}
      </For>
    </div>
  );
}

function BlockView(props: { block: ContentBlock }) {
  const block = props.block;
  if (
    block.type === BLOCK_TYPE.NOTE ||
    block.type === BLOCK_TYPE.RECOMMENDATION
  ) {
    return (
      <>
        <Show when={block.title}>
          <h4>{block.title}</h4>
        </Show>
        <p>{block.body}</p>
      </>
    );
  }
  if (block.type === BLOCK_TYPE.EVIDENCE) {
    return (
      <>
        <Show when={block.title}>
          <h4>{block.title}</h4>
        </Show>
        <Show when={block.source}>
          <div class="mono block-source">{block.source}</div>
        </Show>
        <pre class="ds-evidence">
          <code>{block.body}</code>
        </pre>
      </>
    );
  }
  if (block.type === BLOCK_TYPE.RUBRIC_ITEM) {
    return (
      <>
        <h4>{block.label}</h4>
        <div class="mono block-score">
          {block.score}/{block.maxScore}
        </div>
        <Show when={block.note}>
          <p>{block.note}</p>
        </Show>
      </>
    );
  }
  if (block.type === BLOCK_TYPE.SCORE_COMPONENT) {
    return (
      <>
        <h4>{block.label}</h4>
        <div class="mono block-score">
          {block.score}
          <Show when={block.weight !== null}> · {block.weight}%</Show>
        </div>
        <Show when={block.detail}>
          <p>{block.detail}</p>
        </Show>
      </>
    );
  }
  return (
    <div class="qa">
      <div class="qa-q">{block.q}</div>
      <div class="qa-a">{block.a}</div>
    </div>
  );
}
